var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDirections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.995,
    height: 19.995,
    viewBox: "0 0 19.995 19.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_directions_24px",
    d: "M21.71,11.29l-9-9a1,1,0,0,0-1.41,0l-9,9a1,1,0,0,0,0,1.41l9,9a1,1,0,0,0,1.41,0l9-9a1,1,0,0,0,0-1.41ZM14,14.5V12H10v3H8V11a1,1,0,0,1,1-1h5V7.5L17.5,11Z",
    transform: "translate(-2.008 -1.997)",
    fill: "#25556e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDirections);
export default __webpack_public_path__ + "static/media/ic_directions.6fcb3e7686e49ce1eaaeb833da8aa932.svg";
export { ForwardRef as ReactComponent };